export function getOrgSlug(): string {
  const parts = window.location.hostname.split(/\.(?:admin|app)\./)
  return parts.length > 1 ? parts[0]! : ''
}
